import React, { FC } from 'react';

interface VpnWarningBannerProps {
  onDismiss: () => void;
}

export const VpnWarningBanner: FC<VpnWarningBannerProps> = ({ onDismiss }) => {
  return (
    <div className="relative z-[1000] w-full shrink-0 bg-[#FFF8E1] border-b border-t border-[#F0C040] px-4 py-3 flex items-center min-h-[48px]">
      <div className="absolute inset-0 flex items-center justify-center gap-2 px-4 pointer-events-none">
        <svg className="shrink-0" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 3L2 21h20L12 3z" fill="#92400e" />
          <rect x="11" y="9" width="2" height="6" rx="1" fill="white" />
          <circle cx="12" cy="17.5" r="1" fill="white" />
        </svg>
        <p className="text-sm text-amber-900 leading-snug">
          Возможно, у Вас включён VPN . Он может ухудшать качество связи — рекомендуем отключить его перед сессией.
        </p>
      </div>

      <div className="ml-auto flex items-center gap-2 relative">
        <button
          onClick={onDismiss}
          className="shrink-0 mr-2 cursor-pointer px-6 py-1.5 text-sm border bg-white border-amber-900 rounded-[6px] text-amber-900 hover:bg-amber-900 hover:text-white transition-colors whitespace-nowrap"
        >
          Понятно
        </button>
        <button
          onClick={onDismiss}
          className="shrink-0 text-amber-900 hover:text-amber-700 cursor-pointer transition-colors text-base leading-none px-1"
          aria-label="Закрыть"
        >
          ✕
        </button>
      </div>
    </div>
  );
};
